import React, { useState } from "react";
import PropTypes from "prop-types";
import CascoQuotationsHistoryComponent from "./CascoQuotationsHistoryComponent";
import { useQueryWithSimpleErrorHandling } from "hooks";
import { CASCO_QUOTATIONS_HISTORY_QUERY } from "../queries";
import { INSURANCE_DATA_QUERY } from "features/insuranceDocument/queries/insuranceDocumentQueries";

const CascoQuotationsHistoryContainer = ({ documentId }) => {
  const [cascoQuotationsHistory, setcascoQuotationsHistory] = useState([]);

  const { loading } = useQueryWithSimpleErrorHandling(CASCO_QUOTATIONS_HISTORY_QUERY, {
    variables: { documentId },
    onCompleted: data => {
      setcascoQuotationsHistory(data?.cascoQuotationsHistory);
    },
    fetchPolicy: "network-only"
  });

  const [insuranceData, setInsuranceData] = useState({});

  useQueryWithSimpleErrorHandling(INSURANCE_DATA_QUERY, {
    variables: { documentId },
    skip: !documentId,
    onCompleted: data => {
      setInsuranceData(data?.insuranceData);
    }
  });

  return (
    <CascoQuotationsHistoryComponent
      loading={loading}
      cascoQuotationsHistory={cascoQuotationsHistory}
      currencyCode={insuranceData?.currencyCode}
    />
  );
};

CascoQuotationsHistoryContainer.propTypes = {
  documentId: PropTypes.number.isRequired
};

export default CascoQuotationsHistoryContainer;
